import API from 'services/API';

export const get = () => API.get('/delayType');

export const add = delayType => API.post('/delayType', delayType);

export const del = delayType => API.delete(`/delayType/${delayType}`);
